export default __webpack_public_path__ + "static/media/SpaceGrotesk-Light.e783ead1.woff2";